import General from "../utils/General";

const _isShowSponsoreChannel = (webinarItem) => {
  return (
    webinarItem && webinarItem.webinar_content.sponsorship ||
    webinarItem && webinarItem.webinar_content.channel
  );
};

const _sponsoreChannelCategory = (webinarItem) => {
  var categoryStr = "Dipersembahkan oleh";
  if (webinarItem) {
    if (webinarItem.webinar_content.channel) {
      categoryStr =
        webinarItem.webinar_content.channel.channel_sponsorship_name;
    }
  }
  return categoryStr;
};

const _sponsoreChannelName = (webinarItem) => {
  var nameStr = "";
  if (webinarItem) {
    if (webinarItem.webinar_content.channel) {
      nameStr = webinarItem.webinar_content.channel.name;
    } else if (webinarItem.webinar_content.sponsorship) {
      nameStr = webinarItem.webinar_content.sponsorship.name;
    }
  }
  return nameStr;
};

const _webinarStatusLabel = (webinarItem) => {
  let PUBLISH = "publish";
  let LIVE = "live";
  if (webinarItem) {
    if (webinarItem.webinar_content.broadcast_status === PUBLISH) {
      return "orange-label";
    } else if (webinarItem.webinar_content.broadcast_status === LIVE) {
      return "green-label";
    } else {
      return "black-label";
    }
  }
};

const _sponsoreChannelLogo = (webinarItem) => {
  var logoStr = "";
  if (webinarItem) {
    if (webinarItem.webinar_content.channel) {
      logoStr = webinarItem.webinar_content.channel.logo;
    } else if (webinarItem.webinar_content.sponsorship) {
      logoStr = webinarItem.webinar_content.sponsorship.logo;
    }
  }
  return logoStr;
};

const _isShowPrice = (webinarItem) => {
  return webinarItem && webinarItem.webinar_content.is_paid_webinar;
};

const _isStrikethroughPrice = (webinarItem) => {
  if (webinarItem && webinarItem.webinar_content.payment_info) {
    let base_price = General.getNumber(webinarItem.webinar_content.payment_info.base_price);
    let special_price = General.getNumber(webinarItem.webinar_content.payment_info.normal_price);
    return base_price > special_price;
  }
  return false;
};

const _isWebinarSeries = (webinarItem) => {
  return webinarItem && webinarItem.webinar_type === "series";
};

const _isWebinarSeriesLanding = (webinarItem) => {
    return webinarItem && webinarItem.webinar_content.type === "series"
}

const _isWebinarLiveOrFinished = (webinarItem, isRegistered) => {
  if (webinarItem && (webinarItem.webinar_content.broadcast_status == "live" || webinarItem.webinar_content.broadcast_status == "finished")) {
    if (webinarItem.webinar_content.is_paid_webinar && !isRegistered ) {
      return isRegistered

    } else if (!webinarItem.webinar_content.is_paid_webinar && isRegistered ) {
      return isRegistered

    } else {
      return !isRegistered
    }
    
  } else if (webinarItem && webinarItem.webinar_content.broadcast_status == "finished") {
    if (!isRegistered) {
      return
    }
  }
}

const _isUserRegistered = (webinarItem, isRegistered) => {
  if (webinarItem && (webinarItem.webinar_content.broadcast_status == "live" || webinarItem.webinar_content.broadcast_status == "finished")) {

    if (webinarItem.webinar_content.is_paid_webinar && !isRegistered) {
      return !isRegistered

    } else if (!webinarItem.webinar_content.is_paid_webinar && isRegistered) {
      return isRegistered

    } else if (!isRegistered) {
      return !isRegistered
    }

  } else {
    return !isRegistered
  }
}

const _isWebinarPublishorPaidFinished = (webinarItem, isRegistered) => {
  if (webinarItem && webinarItem.webinar_content.broadcast_status == "live") {
    
    if (webinarItem.webinar_content.is_paid_webinar && !isRegistered) {
      return !isRegistered
    } 

  } else if (webinarItem && webinarItem.webinar_content.broadcast_status == "publish") {
    return !isRegistered

  } else if (webinarItem && webinarItem.webinar_content.broadcast_status == "finished") {
    if (webinarItem.webinar_content.is_paid_webinar && !isRegistered){
      return !isRegistered
    } 
  }
}

const _isShowNextBtn = (webinarList) => {
  return webinarList.length >= 5
}

const _isShowPreviousBtn = (webinarList) => {
  let originPath = window.location.origin + window.location.pathname
  let currentUrl = window.location.href
  let queryParams = (new URL(document.location)).searchParams;
  let currentPagination = queryParams.get('page');

  if (originPath.toString() == currentUrl.toString() || currentPagination == 1){
      return webinarList
  }
}

const _checkEmptyData = (webinarList) => {
  return webinarList.length == 0
}

const _checkMenuOptionsActive = (path) => {
  return path == window.location.pathname && "link-active-blue"
}

const _webinarEventStatus = (webinarEvent) => {
  let PUBLISH = "publish";
  let LIVE = "live";
  if (webinarEvent) {
    if (webinarEvent.broadcast_status === PUBLISH) {
      return "upcoming";
    } else if (webinarEvent.broadcast_status === LIVE) {
      return "live";
    } else {
      return "end";
    }
  }
};

const _getQueryParamPagination = () => {
  var queryParams = new URLSearchParams(window.location.search)
  var page = queryParams.get('page');
  return page ? page : 1;
}

export {
  _isShowSponsoreChannel,
  _sponsoreChannelCategory,
  _sponsoreChannelName,
  _webinarStatusLabel,
  _sponsoreChannelLogo,
  _isShowPrice,
  _isStrikethroughPrice,
  _isWebinarSeries,
  _isWebinarSeriesLanding,
  _isWebinarLiveOrFinished,
  _isUserRegistered,
  _isWebinarPublishorPaidFinished,
  _isShowNextBtn,
  _isShowPreviousBtn,
  _checkEmptyData,
  _checkMenuOptionsActive,
  _getQueryParamPagination,
  _webinarEventStatus
};
